import {NavigateOptions, To, useNavigate} from 'react-router-dom'

const DEBUG_NAVIGATION = false

// Set up this wrapper around useNavigate so that we can turn on DEBUG_NAVIGATION and
// see where and when we are getting redirected.
export function useAppNavigate() {
  const navigate = useNavigate()
  return (to: To | number, opts?: NavigateOptions) => {
    if (DEBUG_NAVIGATION) {
      console.log(`Navigating to ${to} (options = ${JSON.stringify(opts)})`)
      console.trace()
    }
    if (typeof to === 'number') {
      return navigate(to)
    }
    return navigate(to, opts)
  }
}
